"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FloatingLabelInput2 = _interopRequireDefault(require("./FloatingLabelInput"));

var _libphonenumberJs = require("libphonenumber-js");

var _assetMapper = require("../../../../lib/assetMapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _window = window,
    text = _window.text;

var PhoneNumberInput =
/*#__PURE__*/
function (_FloatingLabelInput) {
  _inherits(PhoneNumberInput, _FloatingLabelInput);

  function PhoneNumberInput(_ref) {
    var _this;

    var className = _ref.className,
        id = _ref.id,
        label = _ref.label,
        type = _ref.type,
        allowAllCountries = _ref.allowAllCountries,
        allowedCountries = _ref.allowedCountries;

    _classCallCheck(this, PhoneNumberInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PhoneNumberInput).apply(this, arguments));

    if (!allowAllCountries && !allowedCountries) {
      throw new Error('no allowed countries specified');
    }

    if (allowAllCountries) {
      _this.allowedCountries = _this.allCountries;
    } else {
      _this.allowedCountries = allowedCountries;
    }

    if (_this.allowedCountries) {
      _this.selectedCountry = _this.allowedCountries[0];
    }

    _this.setupMenuWidget();

    return _this;
  }

  _createClass(PhoneNumberInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(PhoneNumberInput.prototype), "render", this).call(this);

      this.$el.addClass('phoneNumberInput ui-front');

      if (this.showCountrySelector) {
        this.$el.prepend("\n                <select class=\"phoneCountrySelector\" aria-label=\"".concat(text('idc.mobileNumberCountryLabel'), "\">\n                    ").concat(this.allowedCountries.map(function (x) {
          return "<option value=\"".concat(x, "\"> ").concat(x, " <img class=\"flagIcon\" src=\"").concat((0, _assetMapper.toStaticUrl)("img/flags/".concat(x.toLowerCase(), ".svg")), "\"/></option>");
        }).join('\n'), "\n                </select>"));
        this.$countrySelect = this.$el.find('.phoneCountrySelector');
        this.$countrySelect.countrySelectMenu({
          change: function change(evt, item) {
            _this2.country = item.item.value;
          },
          icons: {
            button: 'icon-down-arrow'
          }
        });
      }

      this._attachPhoneNumberEvents();

      return this;
    }
  }, {
    key: "setupMenuWidget",
    value: function setupMenuWidget() {
      $.widget('custom.countrySelectMenu', $.ui.selectmenu, {
        _renderItem: function _renderItem(ul, item) {
          var val = item.element.val();
          var listItem = $("<li>\n                     <div>\n                        <img class=\"flagIcon\" src=\"".concat((0, _assetMapper.toStaticUrl)("img/flags/".concat(val.toLowerCase(), ".svg")), "\"/>\n                        <span class=\"countryName\">").concat(text("countryNames.".concat(val.toUpperCase())), "</span>\n                        <span class=\"countryCallingCode\">+").concat((0, _libphonenumberJs.getCountryCallingCode)(val), "</span>\n                </li>"));
          ul.append(listItem);
          return listItem;
        },
        _renderButtonItem: function _renderButtonItem(item) {
          //
          var buttonItem = $("\n                    <div class=\"menuButtonWrapper\"><img class=\"flagIcon\" src='".concat((0, _assetMapper.toStaticUrl)("img/flags/".concat(item.element.val().toLowerCase(), ".svg")), "' /><i class='icon-down-arrow' aria-hidden='true'></i><div>"));
          return buttonItem;
        }
      });
    }
  }, {
    key: "_formatNumber",
    value: function _formatNumber() {
      var current = this.$input.val();

      if (current) {
        var formatted = new _libphonenumberJs.AsYouType(this.selectedCountry).input(current);
        this.$input.val(formatted);
      }
    }
  }, {
    key: "_attachPhoneNumberEvents",
    value: function _attachPhoneNumberEvents() {
      var _this3 = this;

      this.$input.on('input', function () {
        return _this3._formatNumber();
      });

      if (this.$countrySelect) {
        this.$countrySelect.on('change', function () {
          _this3.country = _this3.$countrySelect.val();
        });
      }

      this.$input.on('keydown', function (e) {
        return _this3.onKeydown(e);
      });
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(e) {
      // We need special handing for backspace and delete because of the auto-formatting
      // behavior. Without this, it's impossible to backspace/delete past certain formatting characters
      // because the formatting keeps reinserting them.  User selected text can be handled normally.
      var noSelection = e.target.selectionStart === e.target.selectionEnd;

      if (noSelection && (e.keyCode === 8 || e.keyCode === 46)) {
        var digitsBeforeCursor = this.countPrecedingDigits(e.target.selectionStart);
        var digitsOnly = this.unformattedValue;
        var updated, newCursorPosition;

        if (e.keyCode === 8) {
          // BACKSPACE
          updated = digitsOnly.slice(0, digitsBeforeCursor - 1) + digitsOnly.slice(digitsBeforeCursor);
          newCursorPosition = digitsBeforeCursor;
        } else if (e.keyCode === 46) {
          // DELETE
          updated = digitsOnly.slice(0, digitsBeforeCursor) + digitsOnly.slice(digitsBeforeCursor + 1);
          newCursorPosition = digitsBeforeCursor + 1;
        }

        this.$input.val(updated);

        this._formatNumber();

        this.repositionCursor(newCursorPosition);
        e.preventDefault();
      }
    } // Reposition the cursor following the nth numeric character in the formatted string

  }, {
    key: "repositionCursor",
    value: function repositionCursor(digitIndex) {
      var val = this.$input.val();
      var i = 0;
      var digitsFound = 0;

      for (; i < val.length; ++i) {
        if (digitsFound === digitIndex - 1) {
          break;
        }

        var _char = val.charAt(i);

        if (this.isDigit(_char)) {
          digitsFound++;
        }
      }

      this.$input[0].setSelectionRange(i, i);
    }
  }, {
    key: "isDigit",
    value: function isDigit(c) {
      return /^\d$/.test(c);
    }
  }, {
    key: "countPrecedingDigits",
    value: function countPrecedingDigits(index) {
      var _this4 = this;

      return this.$input.val().slice(0, index).split('').filter(function (c) {
        return _this4.isDigit(c);
      }).length;
    }
  }, {
    key: "countFollowingDigits",
    value: function countFollowingDigits(index) {
      var _this5 = this;

      return this.$input.val().slice(index).split('').filter(function (c) {
        return _this5.isDigit(c);
      }).length;
    }
  }, {
    key: "validate",
    value: function validate() {
      var number = (0, _libphonenumberJs.parsePhoneNumberFromString)(this.$input.val(), this.selectedCountry);

      if (!number || !number.isValid()) {
        this.displayInvalid();
        return false;
      }

      return true;
    }
  }, {
    key: "displayInvalid",
    value: function displayInvalid() {
      if (!this.invalid) {
        _get(_getPrototypeOf(PhoneNumberInput.prototype), "displayInvalid", this).call(this);

        this.$el.addClass('invalid');
        this.invalid = true;
      }
    }
  }, {
    key: "clearInvalid",
    value: function clearInvalid() {
      if (this.invalid) {
        _get(_getPrototypeOf(PhoneNumberInput.prototype), "clearInvalid", this).call(this);

        this.$el.removeClass('invalid');
        this.invalid = false;
      }
    }
  }, {
    key: "floatLabel",
    value: function floatLabel() {
      _get(_getPrototypeOf(PhoneNumberInput.prototype), "floatLabel", this).call(this);

      this.$el.addClass('focused');
    }
  }, {
    key: "sinkLabel",
    value: function sinkLabel() {
      _get(_getPrototypeOf(PhoneNumberInput.prototype), "sinkLabel", this).call(this);

      this.$el.removeClass('focused');
    }
  }, {
    key: "country",
    set: function set(countryCode) {
      this.selectedCountry = countryCode;

      this._formatNumber();

      this.clearInvalid();
    }
  }, {
    key: "showCountrySelector",
    get: function get() {
      return this.allowAllCountries || this.allowedCountries.length > 1;
    }
  }, {
    key: "unformattedValue",
    get: function get() {
      var _this6 = this;

      return this.$input.val().split('').filter(function (c) {
        return _this6.isDigit(c);
      }).join('');
    }
  }, {
    key: "E164",
    get: function get() {
      var parsed = (0, _libphonenumberJs.parsePhoneNumberFromString)(this.$input.val(), this.selectedCountry);
      return parsed ? parsed.number : parsed;
    }
  }, {
    key: "displayValue",
    get: function get() {
      return this.$input.val();
    }
  }, {
    key: "allCountries",
    get: function get() {
      return ['AF', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AG', 'AR', 'AM', 'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BA', 'BW', 'BR', 'IO', 'VG', 'BN', 'BG', 'BF', 'BI', 'KH', 'CM', 'CA', 'IC', 'CV', 'BQ', 'KY', 'CF', 'EA', 'TD', 'CL', 'CN', 'CX', 'CC', 'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'CI', 'HR', 'CU', 'CW', 'CY', 'CZ', 'DK', 'DG', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET', 'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'DE', 'GH', 'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'IR', 'IQ', 'IE', 'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'XK', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP', 'NL', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NU', 'NF', 'KP', 'MK', 'MP', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'XA', 'XB', 'PR', 'QA', 'RE', 'RO', 'RU', 'RW', 'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SX', 'SK', 'SI', 'SB', 'SO', 'ZA', 'GS', 'KR', 'SS', 'ES', 'LK', 'BL', 'SH', 'KN', 'LC', 'MF', 'PM', 'VC', 'SD', 'SR', 'SJ', 'SE', 'CH', 'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TR', 'TM', 'TC', 'TV', 'UM', 'VI', 'UG', 'UA', 'AE', 'GB', 'US', 'UY', 'UZ', 'VU', 'VA', 'VE', 'VN', 'WF', 'EH', 'YE', 'ZM', 'ZW'].filter(function (x) {
        return (0, _libphonenumberJs.isSupportedCountry)(x);
      });
    }
  }]);

  return PhoneNumberInput;
}(_FloatingLabelInput2["default"]);

exports["default"] = PhoneNumberInput;